import React, { useState } from "react";
import { Box ,useMultiStyleConfig,Image, Heading,Button, Link} from "@chakra-ui/react";
import SwiperCore, { Autoplay, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import { useAppSelector } from 'src/redux/hooks';
import HTMLReactParser from 'html-react-parser';
import { Link as RouterLink } from 'react-router-dom';

SwiperCore.use([Autoplay, Pagination]);

export type SlideImage = {
  src: string;
  // Present when the whole slide should redirect on click (e.g. a promo
  // banner whose CTA text/button is baked into the image itself).
  button?: {
    href: string;
    label?: string;
  };
};

type Props = {
  images: SlideImage[];
};

const CarouselSlider = ({ images }: Props) => {
    const styles = useMultiStyleConfig(`HomeBanner`);
    const containerStyle = useMultiStyleConfig(`Container`)
    const data = useAppSelector((state: any) => state.homePage.banner)
    const [activeIndex, setActiveIndex] = useState(0);
    // Slides that carry their own baked-in text/CTA (via `button`) should not
    // show the generic "Enjoy Peace Of Mind..." caption on top of them.
    const showGlobalCaption = !images[activeIndex]?.button;
  return (
    <Box width="100%">
      <Swiper
        autoplay={{ delay: 3000 }}
        pagination={{ clickable: true }}
        loop={true}
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
      >
        {images.map((slide, index) => (
          <SwiperSlide key={index}>
            {slide.button ? (
              <Link
                href={slide.button.href}
                aria-label={slide.button.label || 'banner-link'}
                isExternal
                display="block"
              >
                <Image src={slide.src} alt={`slide-${index}`} sx={{ ...styles.image }} />
              </Link>
            ) : (
              <Image src={slide.src} alt={`slide-${index}`} sx={{ ...styles.image }} />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
      {showGlobalCaption && (
        <Box sx={{ ...styles.caption, ...containerStyle.wrapper }}>
          {data.title ? <Heading as='h1' sx={{ ...styles.title }}>{HTMLReactParser(data.title)}</Heading> : null}
          {data.link ? <Button as={RouterLink} to={data.link.href} sx={{ ...styles.link }}>{data.link.text}</Button> : null}
        </Box>
      )}
    </Box>
  );
};

export default CarouselSlider;